import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const points = ['Te piden un plan para un deportista y no sabés por dónde empezar', 'Calculás macros sin tener claro cómo periodizar según el deporte', 'No sabés qué recomendar antes, durante y después del entrenamiento', 'Te preguntan por suplementos y no tenés respuestas con evidencia', 'Armás planes genéricos porque no tenés protocolos deportivos armados', 'Perdés pacientes deportistas porque sienten que "no es tu fuerte"', 'Sabés que la nutrición deportiva es una oportunidad, pero te falta el sistema para destacarte'];
  return <section className="pt-8 pb-10 px-3 bg-surface border-y border-accent/10" data-id="element-238">
      <div className="max-w-3xl mx-auto" data-id="element-239">
        <FadeIn data-id="element-240">
          <h2 className="text-center text-xl md:text-2xl font-bold mb-6" data-id="element-241">
            <span className="text-white" data-id="element-242">Si sos nutricionista,</span>{' '}
            <span className="text-accent" data-id="element-243">esto te va a sonar familiar:</span>
          </h2>
        </FadeIn>

        <div className="space-y-3 mb-8 max-w-2xl mx-auto" data-id="element-244">
          {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-245">
              <div className="flex items-start gap-3 bg-black/50 p-3 rounded-lg border border-white/5" data-id="element-246">
                <XIcon className="text-red-400 shrink-0 mt-0.5" size={18} data-id="element-247" />
                <span className="text-white/80 text-sm md:text-base" data-id="element-248">
                  {point}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-249">
          <p className="text-center text-lg md:text-xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-accent" data-id="element-250">
            Tu inseguridad profesional tiene solución.
          </p>
        </FadeIn>
      </div>
    </section>;
}